import {ITheme} from 'contexts/ThemeContext';
import {Platform} from 'react-native';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  maxSize,
  minSize,
} from 'rn-responsive-styles';

export default (props: ITheme) =>
  CreateResponsiveStyle(
    {
      container: {flex: 1},
      flatList: {
        flex: 1,
        maxWidth: 1110,
        backgroundColor: props.colors.white,
        marginBottom: 30,
      },
    },
  )();
